import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import {Button} from '@material-ui/core';

import {AddressMarker} from 'common/components/AddressMarkers';
import PlacesAutocomplete from 'common/components/PlacesAutocomplete';
import OndemandMap from 'ondemand/components/OndemandMap';

import styles from './AddressForm.css';


const FALLBACK_POSITION = {lat: 37.0794418, lng: -95.7237823}; // Center of US

const handleName = (onChange) => (event) => onChange('name', event.target.value);

const handleSuggestion = (onChange) => (suggestion) =>
  suggestion.position().then((position) => {
    onChange('position', position);
    onChange('address', suggestion.address);
  });

// convert a list of errors to an object of errors, keyed by parameter
const errorObject = errors => _.indexBy(errors, 'parameter');

const nameError = errors =>
  (errorObject(errors).RiderAddress ? errorObject(errors).RiderAddress.description : null);

const positionError = errors =>
  (errorObject(errors)['position.latitude'] || errorObject(errors)['position.longitude']
    ? 'Location required'
    : null
  );

const AddressForm = ({address, pageDataId, errors, onCancel, onChange, onSave}) => (
  <div data-id={pageDataId} className={styles.root}>
    <div data-id={'address-form-location-input'} className={styles.address}>
      <PlacesAutocomplete
        getSuggestionValue={(suggestion) => suggestion.address}
        onSuggestion={handleSuggestion(onChange)}
        placeholder={address.address || 'Search for a location...'}
        theme={styles}
      />
    </div>
    {positionError(errors) && <div className={styles.errorMessage}>{positionError(errors)}</div>}
    <div data-id={'address-form-label-input'} className={styles.name}>
      <input
        className={classNames(styles.nameInput, {[styles.error]: nameError(errors)})}
        onChange={handleName(onChange)}
        placeholder="Label"
        value={address.name}
      />
    </div>
    {nameError(errors) && <div className={styles.errorMessage}>{nameError(errors)}</div>}
    <div className={styles.map}>
      <OndemandMap
        center={address.position || FALLBACK_POSITION}
        zoom={address.position ? 14 : 2}
      >
        {address.position &&
          <AddressMarker address={Object.assign({}, address, {type: 'rider'})} />}
      </OndemandMap>
    </div>
    <div data-id={'address-form-button-container'} className={styles.buttons}>
      <Button
        data-id={'address-form-cancel-button'}
        color="primary"
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        data-id={'address-form-confirm-button'}
        disabled={!address.position || !address.name}
        onClick={onSave}
      >
        Save
      </Button>
    </div>
  </div>
);

AddressForm.propTypes = {
  address: PropTypes.shape({
    position: PropTypes.object,
  }).isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape({
    parameter: PropTypes.string,
  })),
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  pageDataId: PropTypes.string,
};

export default AddressForm;



// WEBPACK FOOTER //
// ./src/ondemand/components/AddressForm/AddressForm.js